import {ChangeDetectionStrategy, Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {LoadingStatus} from 'amc-common-components';
import {AppState} from '@store';
import {CtsEditModalData, CtsEditModalParams} from '@entities/cts-distribution/cts-distribution.interfaces';
import {ctsDistributionActions} from '@store/cts-distribution/actions';
import {ctsDistributionSelectors} from '@store/cts-distribution/selectors';
import {EditModalComponent} from './edit-modal.component';

/**
 * Edit Modal Container container.
 * @class
 */
@Component({
	selector: 'edit-modal',
	template: `<edit-modal-component
		[data]="data"
		[editStatus]="editStatus$ | async"
		(closed)="onClose()"
		(saveRows)="onSaveRows($event)"
	></edit-modal-component>`,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditModalContainer {
	/**
	 * Auxiliary variable for accessing to Observable of edit status.
	 */
	public readonly editStatus$: Observable<LoadingStatus>;

	/**
	 * Constructor for EditModalContainer.
	 */
	constructor(
		private store: Store<AppState>,
		public dialogRef: MatDialogRef<EditModalComponent>,
		@Inject(MAT_DIALOG_DATA) readonly data: CtsEditModalData
	) {
		this.editStatus$ = this.store.select(ctsDistributionSelectors.savedRows.loadingStatus);
	}

	/**
	 * On close.
	 * @returns {void}
	 */
	public onClose(): void {
		this.dialogRef.close();
	}

	/**
	 * Save rows.
	 * @param {CtsEditModalParams} payload
	 * @returns {void}
	 */
	public onSaveRows(payload: CtsEditModalParams): void {
		this.store.dispatch(ctsDistributionActions.saveRows.requested({payload}));
	}
}
